import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { StaticPageService } from '@app/services/_index';
import { StaticPage } from '@app/models/_index';
import { StaticPageAdapter } from '@app/adapters/_index';
import { StaticPageInterface } from '@app/interfaces/_index';
import { Subscription } from 'rxjs';
import { SubscriptionType } from '@app/enums/_index';

@Component({
  selector: 'app-agent-platform-detail',
  templateUrl: './agent-platform-detail.component.html',
  styleUrls: ['./agent-platform-detail.component.scss'],
  standalone: false,
})
export class AgentPlatformDetailComponent implements OnInit, OnDestroy {
  @Input() name: string;
  sub: Subscription;
  isLoading: boolean;
  contentData: StaticPage;
  images = [];
  constructor(
    private staticPageService: StaticPageService,
    private staticPageAdapter: StaticPageAdapter
  ) {}

  /**
   * OnInit load page
   */
  ngOnInit(): void {
    // TODO: this should be loading form a json file to make this component more generic
    this.images = [
      {
        title: '',
        description: '',
        cta: '',
        route: '',
        imageUrl: 'agent-platform-subscription-banner2.png',
      },
      {
        title: '',
        description: '',
        cta: '',
        route: '',
        imageUrl: 'agent-platform-learning-paths-v2.png',
      },
      {
        title: '',
        description: '',
        cta: '',
        route: '',
        imageUrl: 'agent-platform-supervisor-learning-paths-v2.png',
      },
    ];

    if (this.name === SubscriptionType.AGENT_PLATFORM_SUBSCRIPTION) {
      // TODO: Fix this. Need to unify all the various slugs
      this.name = 'agent-platform-ap-training-for-genesys-cloud-cx';
    }
    this.getSingleTypePage(this.name);
  }

  /**
   * OnDestroy unsubcribe BeyondCX testimonials to prevent memory leaks
   */
  ngOnDestroy(): void {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }

  /**
   * Load Agent Platform Single Page content from Wordpress
   * @param slug - slug string
   */
  getSingleTypePage(slug: string): void {
    this.isLoading = true;
    // NOTE: Wordpress content is coming from the BeyondCX service
    this.sub = this.staticPageService.getStaticPageDetail(slug).subscribe({
      next: (response: StaticPageInterface[]) => {
        if (response && response.length > 0) {
          response.filter((item: StaticPageInterface) => {
            // NOTE: The WordPress Slugified slug (based on page name) should match and
            // return one result
            if (item.slug === this.name) {
              this.contentData = this.staticPageAdapter.adapt(item);
            }
          });
        }
        this.isLoading = false;
      },
      error: (error) => {
        this.isLoading = false;
        console.log(error);
      },
      complete: () => {
        // Force is loading to stop and complete in case of any unhandled errors
        this.isLoading = false;
        console.log('Agent Platform content completed');
      },
    });
  }
}
